import { apiGet, apiPost, apiDelete } from './client';

export type ApiKeyScope = 'ingest' | 'relationships' | 'retrieve' | 'principals';

export const API_KEY_SCOPES: { value: ApiKeyScope; label: string; hint: string }[] = [
  { value: 'retrieve', label: 'Retrieve', hint: 'Secured retrievals, grounded answers, principal and connector lookup. What a RAG service or MCP host needs.' },
  { value: 'ingest', label: 'Ingest', hint: 'Ingest documents and files, manage async ingestion jobs.' },
  { value: 'relationships', label: 'Relationships', hint: 'Create and delete REBAC relationships.' },
  { value: 'principals', label: 'Principals', hint: 'Create, update and deactivate local principals (provisioning pipelines).' },
];

export interface ApiKey {
  id: string;
  name: string;
  /** What the key may do: ingest | relationships | retrieve | principals. */
  scopes: string[];
  prefix: string;
  last_used_at: string | null;
  expires_at: string | null;
  created_at: string;
}

export interface CreateApiKeyResponse extends ApiKey {
  /** Plaintext key -- shown exactly once, never stored by the backend. */
  key: string;
}

export interface CreateApiKeyRequest {
  name: string;
  /** Required. A key is created with exactly the scopes it needs. */
  scopes: ApiKeyScope[];
  expires_at?: string;
}

export async function listApiKeys(): Promise<{ data: ApiKey[] }> {
  return apiGet<{ data: ApiKey[] }>('/api-keys');
}

export async function createApiKey(data: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
  return apiPost<CreateApiKeyResponse>('/api-keys', data);
}

export async function deleteApiKey(id: string): Promise<void> {
  return apiDelete<void>(`/api-keys/${id}`);
}

export async function rotateApiKey(id: string): Promise<CreateApiKeyResponse> {
  return apiPost<CreateApiKeyResponse>(`/api-keys/${id}/rotate`);
}
